import { MerchantGroupQueryParamName } from "src/merchantgroups/objects/MerchantGroupQueryParam";
import { MerchantQueryParamName } from "src/merchants/objects/MerchantQueryParam";
import { StoreQueryParamName } from "src/stores/objects/StoreQueryParam";
import {
  GetPathWithParams,
  type QueryParams,
} from "src/utilities/URLParamsUtils";

export const SUBSCRIBERS_VIEW_PATH = "/su";
export const SUBSCRIBER_DETAIL_VIEW_PATH = "/su/:subscriberUUID";
export const SUBSCRIBER_DETAIL_VIEW_WITH_MESSAGE_TYPE_PATH =
  "/su/:subscriberUUID/:messageType";
export const SUBSCRIBER_EDIT_VIEW_PATH =
  "/su/:subscriberUUID/:messageType/edit";
export const SUBSCRIBERS_VIEW_TERM_PARAM = "term";

export interface IGetSubscribersViewPathParams {
  merchantUuid?: string;
  merchantGroupUuid?: string;
  storeUuid?: string;
  searchTerm?: string;
}

const getSubscriberViewsPath = (
  path: string,
  {
    merchantUuid,
    merchantGroupUuid,
    storeUuid,
    searchTerm,
  }: IGetSubscribersViewPathParams = {},
) => {
  const queryParams: QueryParams = {
    [MerchantQueryParamName]: merchantUuid,
    [MerchantGroupQueryParamName]: merchantGroupUuid,
    [StoreQueryParamName]: storeUuid,
    [SUBSCRIBERS_VIEW_TERM_PARAM]: searchTerm,
  };
  return GetPathWithParams(path, queryParams);
};

// @deprecated use useSubscribersViewPath
export function getSubscribersViewPath(params: IGetSubscribersViewPathParams) {
  return getSubscriberViewsPath(SUBSCRIBERS_VIEW_PATH, params);
}
